import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../utils/api';
import '../AuthLayout.css';

function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Something went wrong. Please try again.');
      }

      setSubmitted(true);
    } catch (err) {
      setError(err.message);
    }

    setLoading(false);
  };

  if (submitted) {
    return (
      <div className="auth-page">
        <div className="auth-bg" style={{ backgroundImage: 'url(/images/login/260318_DGTL_ChariotLoginArt_C4_VeryCompressed.png)' }} />
        <div className="auth-left">
          <div className="auth-container">
            <div className="auth-header">
              <img src="/images/Branding/Horizontal Logo/Chariot_HorizontalLogo_P1_FullColor_011226.png" alt="Chariot" className="auth-logo" />
              <h1>Check Your Email</h1>
              <p className="auth-subtitle">Password reset link sent</p>
            </div>

            <div className="auth-verification">
              <div className="auth-verification-icon">&#9993;</div>
              <p>
                If an account exists with <strong>{email}</strong>, you'll receive a password reset link shortly.
              </p>
              <p className="auth-verification-note">
                The link expires in 1 hour. Check your spam folder if you don't see it.
              </p>
            </div>

            <button
              type="button"
              className="auth-button auth-button-secondary"
              onClick={() => navigate('/login')}
            >
              Back to Sign In
            </button>

            <div className="auth-company">
              <p>Poseidon Marine</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-bg" style={{ backgroundImage: 'url(/images/login/260318_DGTL_ChariotLoginArt_C4_VeryCompressed.png)' }} />
      <div className="auth-left">
        <div className="auth-container">
          <div className="auth-header">
            <img src="/images/Branding/Horizontal Logo/Chariot_HorizontalLogo_P1_FullColor_011226.png" alt="Chariot" className="auth-logo" />
            <h1>Reset Password</h1>
            <p className="auth-subtitle">
              Enter your email and we'll send you a reset link
            </p>
          </div>

          {error && (
            <div className="auth-error">{error}</div>
          )}

          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
                autoComplete="email"
              />
            </div>

            <button
              type="submit"
              className="auth-button"
              disabled={loading}
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>

            <div className="auth-footer">
              <p>
                Remember your password?{' '}
                <button
                  type="button"
                  className="link-button"
                  onClick={() => navigate('/login')}
                >
                  Sign in
                </button>
              </p>
            </div>
          </form>

          <div className="auth-company">
            <p>Poseidon Marine</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
